import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import LangSwitcher from '../components/LangSwitcher'
import Logo from '../components/Logo'

const FeatureIcons: Record<string, React.ReactElement> = {
  motion: (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
      <circle cx="14" cy="7" r="3.5" stroke="#2D7A3A" strokeWidth="2"/>
      <path d="M10 13h8l-2 8H12l-2-8z" stroke="#2D7A3A" strokeWidth="2" strokeLinejoin="round"/>
      <path d="M10 17l-3 4M18 17l3 4" stroke="#2D7A3A" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  bell: (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
      <path d="M14 4a7 7 0 0 1 7 7v4l2 3H5l2-3v-4a7 7 0 0 1 7-7z" stroke="#2D7A3A" strokeWidth="2" strokeLinejoin="round"/>
      <path d="M11.5 18a2.5 2.5 0 0 0 5 0" stroke="#2D7A3A" strokeWidth="2"/>
      <line x1="14" y1="4" x2="14" y2="2" stroke="#2D7A3A" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  sliders: (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
      <line x1="5" y1="9" x2="23" y2="9" stroke="#2D7A3A" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="10" cy="9" r="3" fill="#fff" stroke="#2D7A3A" strokeWidth="2"/>
      <line x1="5" y1="19" x2="23" y2="19" stroke="#2D7A3A" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="18" cy="19" r="3" fill="#fff" stroke="#2D7A3A" strokeWidth="2"/>
    </svg>
  ),
  signal: (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
      <path d="M5 20 Q14 6 23 20" stroke="#2D7A3A" strokeWidth="2" strokeLinecap="round"/>
      <path d="M8.5 20 Q14 10 19.5 20" stroke="#2D7A3A" strokeWidth="2" strokeLinecap="round"/>
      <path d="M12 20 Q14 14 16 20" stroke="#2D7A3A" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="14" cy="21" r="2" fill="#2D7A3A"/>
    </svg>
  ),
}

const PhoneMockup = () => (
  <svg viewBox="0 0 220 420" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', maxWidth: 240 }}>
    <rect x="8" y="0" width="204" height="420" rx="36" fill="#141414"/>
    <rect x="12" y="4" width="196" height="412" rx="33" fill="#f8f9fa"/>
    <rect x="78" y="10" width="64" height="14" rx="7" fill="#141414"/>
    <rect x="12" y="32" width="196" height="56" fill="#fff"/>
    <text x="28" y="56" fontSize="11" fontWeight="700" fill="#1a1a1a" fontFamily="Inter,sans-serif">Dobrý deň, Ivan 👋</text>
    <text x="28" y="72" fontSize="9" fill="#9ca3af" fontFamily="Inter,sans-serif">3 zariadenia online</text>
    <text x="182" y="62" fontSize="18" fill="#9ca3af" fontFamily="Inter,sans-serif">🔔</text>
    <rect x="20" y="100" width="180" height="58" rx="14" fill="#fff" filter="drop-shadow(0 2px 8px rgba(0,0,0,0.07))"/>
    <circle cx="38" cy="129" r="5.5" fill="#2D7A3A"/>
    <text x="52" y="124" fontSize="10" fontWeight="600" fill="#1a1a1a" fontFamily="Inter,sans-serif">Obývačka</text>
    <text x="52" y="138" fontSize="8.5" fill="#9ca3af" fontFamily="Inter,sans-serif">Online · pred 3 min</text>
    <text x="188" y="132" fontSize="14" fill="#d1d5db" fontFamily="sans-serif" textAnchor="end">›</text>
    <rect x="20" y="166" width="180" height="58" rx="14" fill="#fff" filter="drop-shadow(0 2px 8px rgba(0,0,0,0.07))"/>
    <circle cx="38" cy="195" r="5.5" fill="#2D7A3A"/>
    <text x="52" y="190" fontSize="10" fontWeight="600" fill="#1a1a1a" fontFamily="Inter,sans-serif">Spálňa</text>
    <text x="52" y="204" fontSize="8.5" fill="#9ca3af" fontFamily="Inter,sans-serif">Online · pred 8 min</text>
    <text x="188" y="198" fontSize="14" fill="#d1d5db" fontFamily="sans-serif" textAnchor="end">›</text>
    <rect x="20" y="232" width="180" height="58" rx="14" fill="#fff" filter="drop-shadow(0 2px 8px rgba(0,0,0,0.07))"/>
    <circle cx="38" cy="261" r="5.5" fill="#d1d5db"/>
    <text x="52" y="256" fontSize="10" fontWeight="600" fill="#1a1a1a" fontFamily="Inter,sans-serif">Garáž</text>
    <text x="52" y="270" fontSize="8.5" fill="#9ca3af" fontFamily="Inter,sans-serif">Offline · pred 3 hod</text>
    <text x="188" y="264" fontSize="14" fill="#d1d5db" fontFamily="sans-serif" textAnchor="end">›</text>
    <rect x="16" y="308" width="188" height="66" rx="16" fill="#fff" filter="drop-shadow(0 6px 20px rgba(0,0,0,0.13))"/>
    <circle cx="38" cy="335" r="11" fill="#f0fdf4" stroke="#2D7A3A" strokeWidth="1.5"/>
    <circle cx="38" cy="335" r="5.5" fill="#2D7A3A"/>
    <text x="56" y="330" fontSize="9" fontWeight="700" fill="#1a1a1a" fontFamily="Inter,sans-serif">Obývačka</text>
    <text x="56" y="343" fontSize="8.5" fill="#555" fontFamily="Inter,sans-serif">🏃 Pohyb zaznamenaný</text>
    <text x="56" y="356" fontSize="7.5" fill="#9ca3af" fontFamily="Inter,sans-serif">Práve teraz</text>
    <rect x="158" y="322" width="38" height="18" rx="9" fill="#f0fdf4"/>
    <text x="177" y="334" fontSize="8" fill="#2D7A3A" fontWeight="600" fontFamily="Inter,sans-serif" textAnchor="middle">Otvoriť</text>
    <rect x="12" y="388" width="196" height="28" rx="0" fill="#fff"/>
    <rect x="12" y="404" width="196" height="12" rx="0 0 33 33" fill="#fff"/>
    <rect x="82" y="408" width="56" height="5" rx="2.5" fill="#141414"/>
  </svg>
)

export default function Landing() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [openFaq, setOpenFaq] = useState<number | null>(null)

  const stats = t('landing.stats', { returnObjects: true }) as { value: string; label: string }[]
  const testimonials = t('landing.testimonials', { returnObjects: true }) as { text: string; name: string; role: string }[]
  const appPreviewPoints = t('landing.appPreviewPoints', { returnObjects: true }) as string[]
  const features = t('landing.features', { returnObjects: true }) as { iconKey: string; title: string; desc: string }[]
  const steps = t('landing.steps', { returnObjects: true }) as { num: string; title: string; desc: string }[]
  const pricing = t('landing.pricing', { returnObjects: true }) as { name: string; price: string; note: string; desc: string; features: string[]; cta: string; highlight: boolean }[]
  const faq = t('landing.faq', { returnObjects: true }) as { q: string; a: string }[]

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#fff', fontFamily: "'Inter', -apple-system, sans-serif" }}>
      {/* Nav */}
      <div style={{ borderBottom: '1px solid #f0f0f0', position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 10 }}>
        <div style={{ maxWidth: 900, margin: '0 auto', padding: '14px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Logo size={44} />
          <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
            <LangSwitcher />
            <button onClick={() => navigate('/login')} style={{ background: 'none', border: '1.5px solid #e0e0e0', borderRadius: 10, padding: '8px 18px', fontSize: 14, fontWeight: 600, color: '#555', cursor: 'pointer' }}>
              {t('landing.ctaLogin')}
            </button>
            <button onClick={() => navigate('/order')} style={{ background: '#2D7A3A', border: 'none', borderRadius: 10, padding: '8px 18px', fontSize: 14, fontWeight: 600, color: '#fff', cursor: 'pointer' }}>
              {t('landing.order')}
            </button>
          </div>
        </div>
      </div>

      {/* Hero */}
      <div style={{ maxWidth: 900, margin: '0 auto', padding: '56px 20px 48px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 48, flexWrap: 'wrap' }}>
          <div style={{ flex: '1 1 320px', minWidth: 280 }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, backgroundColor: '#f0fdf4', color: '#2D7A3A', fontSize: 13, fontWeight: 600, padding: '6px 14px 6px 8px', borderRadius: 20, marginBottom: 24 }}>
              <Logo size={22} />
              {t('landing.badge')}
            </div>
            <h1 style={{ fontSize: 44, fontWeight: 800, color: '#1a1a1a', margin: '0 0 20px', lineHeight: 1.15, letterSpacing: -1 }}>
              {t('landing.heroTitle')}
            </h1>
            <p style={{ fontSize: 17, color: '#555', margin: '0 0 32px', lineHeight: 1.7 }}>{t('landing.heroSub')}</p>
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 14 }}>
              <button onClick={() => navigate('/order')} style={{ backgroundColor: '#2D7A3A', border: 'none', borderRadius: 12, padding: '14px 28px', fontSize: 15, fontWeight: 700, color: '#fff', cursor: 'pointer', boxShadow: '0 4px 20px rgba(45,122,58,0.3)' }}>
                {t('landing.ctaOrder')}
              </button>
              <button onClick={() => navigate('/register')} style={{ background: 'none', border: '1.5px solid #e0e0e0', borderRadius: 12, padding: '14px 24px', fontSize: 15, fontWeight: 600, color: '#555', cursor: 'pointer' }}>
                {t('landing.ctaRegister')}
              </button>
            </div>
            <p style={{ fontSize: 13, color: '#9ca3af', margin: 0 }}>{t('landing.ctaNote')}</p>
          </div>
          <div style={{ flex: '0 0 240px', display: 'flex', justifyContent: 'center' }}>
            <PhoneMockup />
          </div>
        </div>
      </div>

      {/* Social proof strip */}
      <div style={{ borderTop: '1px solid #f0f0f0', borderBottom: '1px solid #f0f0f0', padding: '18px 20px' }}>
        <div style={{ maxWidth: 900, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 24, flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ display: 'flex' }}>
              {['#fbbf24', '#60a5fa', '#34d399', '#f472b6'].map((color, i) => (
                <div key={i} style={{ width: 30, height: 30, borderRadius: 15, backgroundColor: color, border: '2px solid #fff', marginLeft: i > 0 ? -8 : 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13 }}>
                  {['👴', '👵', '👨', '👩'][i]}
                </div>
              ))}
            </div>
            <span style={{ fontSize: 14, color: '#555' }}>{t('landing.socialProof')} <strong style={{ color: '#1a1a1a' }}>{t('landing.socialFamilies')}</strong></span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <span style={{ color: '#f59e0b', fontSize: 16, letterSpacing: 1 }}>★★★★★</span>
            <span style={{ fontSize: 14, fontWeight: 700, color: '#1a1a1a' }}>{t('landing.socialRating')}</span>
          </div>
        </div>
      </div>

      {/* Stats */}
      <div style={{ maxWidth: 900, margin: '0 auto', padding: '40px 20px 0' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 16 }}>
          {stats.map((s, i) => (
            <div key={i} style={{ textAlign: 'center', padding: '20px 16px', backgroundColor: '#f8f9fa', borderRadius: 16 }}>
              <div style={{ fontSize: 28, fontWeight: 800, color: '#2D7A3A', marginBottom: 6 }}>{s.value}</div>
              <div style={{ fontSize: 12, color: '#888', lineHeight: 1.4 }}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Testimonials */}
      <div style={{ maxWidth: 900, margin: '0 auto', padding: '32px 20px 0' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 16 }}>
          {testimonials.map((item, i) => (
            <div key={i} style={{ backgroundColor: '#f8f9fa', borderRadius: 16, padding: '20px 22px' }}>
              <p style={{ fontSize: 14, color: '#444', margin: '0 0 14px', lineHeight: 1.65, fontStyle: 'italic' }}>"{item.text}"</p>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{ width: 34, height: 34, borderRadius: 17, backgroundColor: i === 0 ? '#f0fdf4' : '#eff6ff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16 }}>{i === 0 ? '👩' : '👨'}</div>
                <div>
                  <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: '#1a1a1a' }}>{item.name}</p>
                  <p style={{ margin: 0, fontSize: 12, color: '#9ca3af' }}>{item.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Features */}
      <div style={{ backgroundColor: '#f8f9fa', padding: '56px 20px', marginTop: 40 }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <h2 style={{ fontSize: 28, fontWeight: 700, color: '#1a1a1a', textAlign: 'center', margin: '0 0 8px' }}>{t('landing.featuresTitle')}</h2>
          <p style={{ fontSize: 15, color: '#888', textAlign: 'center', margin: '0 0 36px' }}>{t('landing.featuresSub')}</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16 }}>
            {features.map((f, i) => (
              <div key={i} style={{ backgroundColor: '#fff', borderRadius: 20, padding: '24px 22px', boxShadow: '0 2px 12px rgba(0,0,0,0.05)' }}>
                <div style={{ width: 48, height: 48, borderRadius: 14, backgroundColor: '#f0fdf4', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 14 }}>
                  {FeatureIcons[f.iconKey]}
                </div>
                <h3 style={{ fontSize: 15, fontWeight: 700, color: '#1a1a1a', margin: '0 0 8px' }}>{f.title}</h3>
                <p style={{ fontSize: 13, color: '#777', margin: 0, lineHeight: 1.6 }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* App preview */}
      <div style={{ maxWidth: 900, margin: '0 auto', padding: '56px 20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 56, flexWrap: 'wrap' }}>
          <div style={{ flex: '0 0 240px', display: 'flex', justifyContent: 'center' }}>
            <PhoneMockup />
          </div>
          <div style={{ flex: '1 1 280px' }}>
            <h2 style={{ fontSize: 28, fontWeight: 700, color: '#1a1a1a', margin: '0 0 10px' }}>{t('landing.appPreviewTitle')}</h2>
            <p style={{ fontSize: 15, color: '#888', margin: '0 0 28px', lineHeight: 1.6 }}>{t('landing.appPreviewSub')}</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              {appPreviewPoints.map((point, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                  <div style={{ width: 22, height: 22, borderRadius: 11, backgroundColor: '#f0fdf4', border: '1.5px solid #2D7A3A', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: 1 }}>
                    <svg width="10" height="10" viewBox="0 0 10 10"><path d="M2 5l2.5 2.5L8 3" stroke="#2D7A3A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/></svg>
                  </div>
                  <span style={{ fontSize: 14, color: '#444', lineHeight: 1.6 }}>{point}</span>
                </div>
              ))}
            </div>
            <button onClick={() => navigate('/register')} style={{ marginTop: 28, backgroundColor: '#2D7A3A', border: 'none', borderRadius: 12, padding: '13px 24px', fontSize: 14, fontWeight: 700, color: '#fff', cursor: 'pointer' }}>
              {t('landing.ctaRegister')} →
            </button>
          </div>
        </div>
      </div>

      {/* How it works */}
      <div style={{ backgroundColor: '#f8f9fa', padding: '56px 20px' }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <h2 style={{ fontSize: 28, fontWeight: 700, color: '#1a1a1a', textAlign: 'center', margin: '0 0 8px' }}>{t('landing.stepsTitle')}</h2>
          <p style={{ fontSize: 15, color: '#888', textAlign: 'center', margin: '0 0 36px' }}>{t('landing.stepsSub')}</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {steps.map((s, i) => (
              <div key={i} style={{ display: 'flex', gap: 20, alignItems: 'flex-start', backgroundColor: '#fff', borderRadius: 16, padding: '20px 22px', boxShadow: '0 2px 10px rgba(0,0,0,0.04)' }}>
                <div style={{ width: 40, height: 40, borderRadius: 20, backgroundColor: '#2D7A3A', color: '#fff', fontSize: 18, fontWeight: 800, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{s.num}</div>
                <div>
                  <p style={{ fontSize: 16, fontWeight: 700, color: '#1a1a1a', margin: '0 0 4px' }}>{s.title}</p>
                  <p style={{ fontSize: 14, color: '#777', margin: 0 }}>{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Pricing */}
      <div style={{ maxWidth: 900, margin: '0 auto', padding: '56px 20px' }}>
        <h2 style={{ fontSize: 28, fontWeight: 700, color: '#1a1a1a', textAlign: 'center', margin: '0 0 8px' }}>{t('landing.pricingTitle')}</h2>
        <p style={{ fontSize: 15, color: '#888', textAlign: 'center', margin: '0 0 36px' }}>{t('landing.pricingSub')}</p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 20 }}>
          {pricing.map((plan, i) => (
            <div key={i} style={{ borderRadius: 20, padding: '28px 26px', border: plan.highlight ? '2px solid #2D7A3A' : '1.5px solid #e5e7eb', backgroundColor: plan.highlight ? '#f0fdf4' : '#fff', position: 'relative' }}>
              {plan.highlight && (
                <div style={{ position: 'absolute', top: -12, left: '50%', transform: 'translateX(-50%)', backgroundColor: '#2D7A3A', color: '#fff', fontSize: 11, fontWeight: 700, padding: '4px 14px', borderRadius: 20, whiteSpace: 'nowrap' }}>
                  {t('landing.recommended')}
                </div>
              )}
              <h3 style={{ fontSize: 18, fontWeight: 700, color: '#1a1a1a', margin: '0 0 4px' }}>{plan.name}</h3>
              <p style={{ fontSize: 13, color: '#888', margin: '0 0 16px' }}>{plan.desc}</p>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, marginBottom: 20 }}>
                <span style={{ fontSize: 36, fontWeight: 800, color: '#1a1a1a' }}>{plan.price}</span>
                <span style={{ fontSize: 13, color: '#9ca3af' }}>{plan.note}</span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 24 }}>
                {plan.features.map((f, j) => (
                  <div key={j} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div style={{ width: 18, height: 18, borderRadius: 9, backgroundColor: '#2D7A3A', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      <svg width="9" height="9" viewBox="0 0 9 9"><path d="M1.5 4.5l2 2L7.5 2" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/></svg>
                    </div>
                    <span style={{ fontSize: 13, color: '#444' }}>{f}</span>
                  </div>
                ))}
              </div>
              <button onClick={() => navigate('/order')} style={{ width: '100%', padding: '13px', borderRadius: 12, border: 'none', backgroundColor: plan.highlight ? '#2D7A3A' : '#1a1a1a', color: '#fff', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>
                {plan.cta}
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* FAQ */}
      <div style={{ backgroundColor: '#f8f9fa', padding: '56px 20px' }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <h2 style={{ fontSize: 28, fontWeight: 700, color: '#1a1a1a', textAlign: 'center', margin: '0 0 32px' }}>{t('landing.faqTitle')}</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {faq.map((item, i) => (
              <div key={i} style={{ backgroundColor: '#fff', borderRadius: 16, boxShadow: '0 2px 10px rgba(0,0,0,0.04)', overflow: 'hidden' }}>
                <button
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                  style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '18px 20px', background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left', gap: 12 }}
                >
                  <span style={{ fontSize: 15, fontWeight: 700, color: '#1a1a1a' }}>{item.q}</span>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2.5" strokeLinecap="round" style={{ flexShrink: 0, transform: openFaq === i ? 'rotate(180deg)' : 'none', transition: 'transform .2s' }}>
                    <polyline points="6 9 12 15 18 9"/>
                  </svg>
                </button>
                {openFaq === i && (
                  <div style={{ padding: '0 20px 18px' }}>
                    <p style={{ fontSize: 14, color: '#666', margin: 0, lineHeight: 1.65 }}>{item.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA */}
      <div style={{ backgroundColor: '#2D7A3A', padding: '56px 20px', textAlign: 'center' }}>
        <h2 style={{ fontSize: 28, fontWeight: 700, color: '#fff', margin: '0 0 12px' }}>{t('landing.ctaTitle')}</h2>
        <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.8)', margin: '0 0 28px' }}>{t('landing.ctaSub')}</p>
        <button onClick={() => navigate('/order')} style={{ backgroundColor: '#fff', border: 'none', borderRadius: 14, padding: '16px 36px', fontSize: 16, fontWeight: 700, color: '#2D7A3A', cursor: 'pointer' }}>
          {t('landing.ctaBtn')}
        </button>
      </div>

      {/* Footer */}
      <div style={{ borderTop: '1px solid #f0f0f0', padding: '32px 20px', textAlign: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
          <Logo size={36} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 24, flexWrap: 'wrap', marginBottom: 16 }}>
          <button onClick={() => navigate('/order')} style={{ background: 'none', border: 'none', fontSize: 14, color: '#555', cursor: 'pointer' }}>{t('landing.order')}</button>
          <button onClick={() => navigate('/support')} style={{ background: 'none', border: 'none', fontSize: 14, color: '#555', cursor: 'pointer' }}>{t('landing.footerSupport')}</button>
          <button onClick={() => navigate('/privacy')} style={{ background: 'none', border: 'none', fontSize: 14, color: '#555', cursor: 'pointer' }}>{t('landing.footerPrivacy')}</button>
          <button onClick={() => navigate('/terms')} style={{ background: 'none', border: 'none', fontSize: 14, color: '#555', cursor: 'pointer' }}>{t('landing.footerTerms')}</button>
        </div>
        <p style={{ fontSize: 12, color: '#bbb', margin: 0 }}>© 2026 Vigilant · vigilantapp.io</p>
      </div>
    </div>
  )
}
